import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import { useFulfilmentLocationContext } from '../../../components/FulfilmentLocationProvider';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import EditFulfilmentLocationDrawer from '../../../components/EditFulfilmentLocationDrawer';
import Address from '@afosto/app-components-react/Address';
import Property from '@afosto/app-components-react/Property';
import getFullName from '@afosto/utils/getFullName';
import translations from './translations';

const FulfilmentLocationDetails = () => {
  const [hasPermissions] = usePermissions(['lcs:locations:write']);
  const intl = useIntl();
  const { fulfilmentLocation = {}, setShouldLoadLocation } = useFulfilmentLocationContext();
  const [showEditLocationInformation, setShowEditLocationInformation] = useState(false);
  const { address = {} } = fulfilmentLocation;

  const handleUpdateLocation = () => {
    setShouldLoadLocation(true);
    setShowEditLocationInformation(false);
  };

  return (
    <>
      <Card style={{ height: '100%' }}>
        <CardHeader
          title={intl.formatMessage(translations.card.title)}
          titleTypographyProps={{ variant: 'h6' }}
          action={
            fulfilmentLocation &&
            hasPermissions() && (
              <Button variant="outlined" onClick={() => setShowEditLocationInformation(true)}>
                {intl.formatMessage(translations.card.button)}
              </Button>
            )
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Property
                label={intl.formatMessage(translations.fields.name)}
                value={fulfilmentLocation?.name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Property
                label={intl.formatMessage(translations.fields.address)}
                value={
                  <Address
                    city={address?.locality}
                    company={address?.organisation}
                    country={address?.country_code}
                    fullName={getFullName(address)}
                    postalCode={address?.postal_code}
                    addressLine1={address?.address_line_1}
                    addressLine2={address?.address_line_2}
                    administrativeArea={address?.administrative_area}
                  />
                }
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <EditFulfilmentLocationDrawer
        location={fulfilmentLocation}
        onSuccess={handleUpdateLocation}
        onClose={() => setShowEditLocationInformation(false)}
        open={showEditLocationInformation}
      />
    </>
  );
};

export default FulfilmentLocationDetails;
